<script>
	import Drive from "./Drive.svelte";
	import Exterior from "./Exterior.svelte";
	import { Col, Row } from "@sveltestrap/sveltestrap";
	import Tabs from "../../../../components/Tabs/Tabs.svelte";
	import { onDestroy } from "svelte";
	import {
		issueNumber,
		carIssueOpen,
		carIssueData,
	} from "../../../../store/store";

	export let detailData;

	let activeTab = 1;
	const options = {
		rewind: true,
		perPage: 2,
		gap: "1px",
		autoWidth: true,
		height: "15rem",
		arrows: true,
	};

	let items = [
		{
			label: "Exterior",
			value: 1,
			component: Exterior,
		},
		{
			label: "Drive",
			value: 2,
			component: Drive,
		},
	];

	onDestroy(() => {
		carIssueOpen.set(false);
		issueNumber.set("");
		carIssueData.set("");
	});
</script>

<Row class="">
	<Col xs={12}>
		<div>
			<Col>
				<Tabs {items} {options} {activeTab} {detailData} />
			</Col>
		</div>
	</Col>
</Row>
